import { Notification } from 'element-ui'

exports.install = function (Vue, options) {
  // 编码
  Vue.prototype.BaseEncode = function (params) {
    let Base64 = require('js-base64').Base64
    return Base64.encode(params)
  }
  // 解码
  Vue.prototype.BaseDecode = function (params) {
    let Base64 = require('js-base64').Base64
    return Base64.decode(params)
  }

  // 成功通知
  Vue.prototype.success = function (message) {
    Notification({
      title: '成功',
      message: message,
      type: 'success',
      duration: 2000
    })
  }

  // 失败通知
  Vue.prototype.error = function (message) {
    Notification({
      title: '错误',
      message: message,
      type: 'error',
      duration: 3000
    })
  }

  // 警告通知
  Vue.prototype.warning = function (message) {
    Notification({
      title: '警告',
      message: message,
      type: 'warning',
      duration: 3000
    })
  }
  Vue.prototype.dateTrasFormat = function (date,fmt) {
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    }
}



// WEBPACK FOOTER //
// ./src/utils/global/index.js